module.exports = __webpack_public_path__ + "static/architecture-0e86b6ba4296c9ebe3e647ad11141e2d.png";